import { CompanyProfileProps } from '@/pages/empresa/[empresa]';
import { CelebrityProfileProps } from '@/pages/celebridade/[celebridade]';
import { AuthorProfileProps } from '@/pages/equipe/[autor]';
import ProfileBio from './ProfileBio';
import ContentComposer from '../Internals/ContentComposer';
import ProfileLinks from './ProfileHeader/ProfileLinks';
import { ProfileHeaderContainer, ProfileHeaderCover, ProfileHeaderTitle } from './ProfileHeader/styles';
import AdsGeneratorMemo from '../Ads/Google/AdsTypeGeneratorsMemo';
import HeaderImageComponent from '../Internals/HeaderImage/Image';

type ProfilePageProps = CompanyProfileProps['responseData']['data'] &
  CelebrityProfileProps['responseData']['data'] &
  AuthorProfileProps['responseData']['data'] & { type: 'empresa' | 'celebridade' | 'autor' };

const formatDate = (date: string) =>
  date.length > 4
    ? new Intl.DateTimeFormat('pt-Br', { timeZone: 'UTC', dateStyle: 'long' }).format(new Date(date))
    : new Intl.DateTimeFormat('pt-Br', { timeZone: 'UTC', year: 'numeric' }).format(new Date(date));

const formatSpaceTime = ({ date, place }: { date?: string; place?: string }) => {
  if (date && place) return `${formatDate(date)} em ${place}`;
  if (date) return formatDate(date);
  if (place) return place;
  return '';
};

export default function ProfilePage({ nome, imagem, links, codigoBolsa, subsidiariaDe, fundacao, nascimento, morte, texto, type }: ProfilePageProps) {
  const hasBirth = nascimento && (nascimento.data || nascimento.local);
  const hasDeath = morte && (morte.data || morte.local);
  const hasFoundation = fundacao && (fundacao.data || fundacao.local);

  return (
    <>
      <ProfileHeaderCover blueBackground={type === 'autor'} />
      <div className="mx-auto mb-6 mt-0 flex max-w-full flex-col gap-6 tablet:max-w-[calc(100%-336px-32px)] [&_#content-news>div:first-of-type]:float-none [&_#content-news>div:first-of-type]:mx-auto [&_#content-news>div:first-of-type]:mb-6 [&_#content-news>div:first-of-type]:mt-0 largeDesktop:[&_#content-news>div:first-of-type]:float-right largeDesktop:[&_#content-news>div:first-of-type]:mb-0 largeDesktop:[&_#content-news>div:first-of-type]:ml-6 [&_#content-news]:block">
        <ProfileHeaderContainer round={type !== 'empresa'}>
          <HeaderImageComponent src={imagem.url} width={120} height={120} alt={nome} />
          <ProfileHeaderTitle>{nome}</ProfileHeaderTitle>
          {links && Object.values(links).length > 0 && <ProfileLinks links={links} type={type} />}
        </ProfileHeaderContainer>
        {(hasBirth || hasDeath || hasFoundation || codigoBolsa || subsidiariaDe) && (
          <section className="flex flex-col gap-4 rounded-lg border border-solid border-mglGray200 p-4 font-light text-mglGray900">
            {nascimento && <ProfileBio title="Nascimento" content={formatSpaceTime({ date: nascimento.data, place: nascimento.local })} />}
            {morte && <ProfileBio title="Morte" content={formatSpaceTime({ date: morte.data, place: morte.local })} />}
            {fundacao && <ProfileBio title="Fundação" content={formatSpaceTime({ date: fundacao.data, place: fundacao.local })} />}
            {codigoBolsa && <ProfileBio title="Código da Bolsa" content={codigoBolsa} />}
            {subsidiariaDe && <ProfileBio title="Subsidiária de" content={subsidiariaDe} />}
          </section>
        )}
        <section id="content-news">
          {type !== 'autor' && (
            <div style={{ width: '336px', height: '300px', backgroundColor: 'rgba(0, 0, 0, 0.06)' }}>
              <AdsGeneratorMemo type="rectangle/main/internal" marginBottomP="24px" />
            </div>
          )}
          {texto &&
            (typeof texto === 'string' ? (
              <p>{texto}</p>
            ) : (
              texto.map((element, index) => (
                <ContentComposer
                  tipo={element.tipo}
                  as={element.tag}
                  url={element.url}
                  target={element.target}
                  valor={element?.valor}
                  atributos={element?.atributos}
                  // eslint-disable-next-line react/no-array-index-key
                  key={`${element.tipo}-${index}`}
                />
              ))
            ))}
        </section>
      </div>
    </>
  );
}
